import JwtDecode from 'jwt-decode';
import Vue from 'vue';
import Vuex from 'vuex';
import api from '@/api.js';
import campaigns from './campaigns';
import users from './users';
import items from './items';
import brandTypes from './brandTypes';
import questions from './questions';
import withdrawals from './withdrawals';
import classes from './classes';
import branches from './branches';
import partners from './partners';
import brands from './brands';
import profiles from './profiles';
import router from '@/router';
import VuexPersist from 'vuex-persist';

Vue.use(Vuex);

const vuexPersist = new VuexPersist({
  storage: window.localStorage,
});

const store = () =>
  new Vuex.Store({
    modules: {
      campaigns,
      users,
      items,
      brandTypes,
      withdrawals,
      branches,
      partners,
      brands,
      profiles,
      classes,
      questions,
    },
    state: {
      auth: null,
      userData: null,
      amount: null,
      loading: false,
      hasBrand: false,
    },
    getters: {
      getAmount(state) {
        return state.amount;
      },
      getUserData(state) {
        return state.userData;
      },
      getToken(state) {
        return state.auth;
      },
      getLoading(state) {
        return state.loading;
      },
      checkBrand(state) {
        return state.hasBrand;
      },
    },
    mutations: {
      SET_AUTH(state, auth) {
        let decodedToken = JwtDecode(auth);
        state.auth = auth;
        state.userData = decodedToken;
        state.amount = decodedToken.amount;
        localStorage.setItem('auth', state.auth);
        api.defaults.headers.common.Authorization = `Bearer ${state.auth}`;
        // router.push({ name: "marcas" });
      },
      LOGOUT(state) {
        router.push('/login');
      },
      SET_LOADING(state, loading) {
        state.loading = loading;
      },
      CHECK_BRAND(state, brand) {
        state.hasBrand = brand;
      },
      SET_AMOUNT(state, amount) {
        state.amount = amount;
      },
    },
    actions: {
      checkBrand({ state, commit }, brand) {
        commit('CHECK_BRAND', brand);
      },
      setLoading({ state, commit }, loading) {
        commit('SET_LOADING', loading);
      },
      setAuth({ state, commit }, auth) {
        commit('SET_AUTH', auth);
      },
      async doLogin({ state, commit }, userData) {
        try {
          const res = await api.post('auth/admin', userData);
          commit('SET_AUTH', res.data.token);
        } catch (error) {}
      },
      async doLogout({ state, commit }) {
        commit('LOGOUT');
      },
    },
    plugins: [vuexPersist.plugin],
  });

export default store;
